export default {
  ADMIN_HOME: 'home',
  ADMIN: 'admin',
  ADMIN_LOGIN: 'login',
  ADMIN_APP: 'admin_app',
  USERS:'users',
  CAMPAIGNS:'campaigns'
}
